import React from "react";

import '../style/HomePageAlerts.css';

const HomePageAlerts = () => {
  return (
    <section className="hero is-warning home-page-alerts">
      <div className="container">
        <div className="has-text-centered">
          <p className="is-error">Be advised: this webpage is still under construction</p>
        </div>
      </div>
    </section>
  );
};

export default HomePageAlerts;